<template>
    <v-alert
        v-if="displayAlert"
        type="warning"
        :class="alertClass ?? 'px-4 py-2'"
        :data-cy="cypressData"
        density="compact"
        rounded="lg"
    >
        <template #title>
            <p class="body-medium font-weight-bold">
                Compliance Information Incomplete
            </p>
        </template>
        <p class="body-medium">
            Your account compliance verification is incomplete. Please provide
            any missing compliance details.
            <span
                class="default-text-button font-weight-medium body-medium"
                @click="
                    redirectToRoute({ name: OrganisationRouteNames.GOVERNANCE })
                "
                >Click here to complete it now.</span
            >
        </p>
    </v-alert>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { usePiniaStore } from "@/stores/store";

import { redirectToRoute } from "@/router";
import { OrganisationRouteNames } from "@/constants/routes";

defineProps<{
    cypressData?: string;
    alertClass?: string;
}>();

const pStore = usePiniaStore();
const displayAlert = computed(() => {
    const schoolDetails = pStore.getSchoolSettings;
    return schoolDetails?.compliance_required === true;
});
</script>
